import { localStateProductSelector } from "@client/content/modules/ProductDetail/selectors";
import { makeModuleI18nSelector } from "@client/content/selectors";
import { type FormFieldInfo } from "@client/controls/Form/component";
import Checkbox from "@client/controls/Inputs/Checkbox/component";
import EmailInput from "@client/controls/Inputs/Email/component";
import RateInput from "@client/controls/Inputs/Rate/component";
import TextArea from "@client/controls/Inputs/TextArea/component";
import appInfo from "@common/appInfo";
import { fieldValidation } from "@common/controls/Form/Field/lib";
import { createSelector } from "reselect";

export const makeFieldsSelector = () => {
  const moduleI18nSelector = makeModuleI18nSelector();

  return createSelector([moduleI18nSelector, localStateProductSelector], (i18n, product): FormFieldInfo[] => {
    const fields: FormFieldInfo[] = [
      {
        name: "rating",
        label: i18n.rating,
        Component: RateInput,
        defaultValue: product?.userReview?.rating ?? 10,
        componentOpts: { className: "" },
        isNoStyle: true
      },
      {
        name: "review",
        label: i18n.review,
        isRequired: true,
        Component: TextArea,
        defaultValue: product?.userReview?.review ?? "",
        componentOpts: { rows: 5 }
      },
      {
        name: "isAnonymous",
        Component: Checkbox,
        componentOpts: {
          label: i18n.anonymous
        },
        defaultValue: product?.userReview ? !product?.userReview.userLastName : false,
        isNoStyle: true
      }
    ];

    if (!appInfo.user && !product?.userReview) {
      fields.splice(1, 0, {
        name: "email",
        Component: EmailInput,
        validation: fieldValidation.email,
        label: i18n.email,
        isRequired: true,
        defaultValue: ""
      });
    }

    return fields;
  });
};
